import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PendingContract } from "@edp-models/edp-pending-contract.model";

@Component({
    selector: "edp-card-pending-approval",
    templateUrl: "./edp-card-pending-approval.component.html",
    styleUrls: ["./edp-card-pending-approval.component.scss"],
})
export class EdpCardPendingApprovalComponent {
    @Input() pendingContract: PendingContract;
    @Output() removeHandle = new EventEmitter();

    public onRemove(event: any) {
        this.removeHandle.emit(event);
    }
}
